import {
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import { DefaultRowCell } from "components/table-v2/row-cells";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical } from "@fortawesome/pro-solid-svg-icons";
import { FC } from "react";

interface IProps {
  handleEdit: () => void;
  handleRemove: () => void;
}

export const LeadInactivityTableActionCell: FC<IProps> = ({
  handleEdit,
  handleRemove,
}) => {
  return (
    <DefaultRowCell
      justifyContent={"flex-end"}
      onClick={event => event.stopPropagation()}
    >
      <Menu isLazy={true} placement={"bottom-end"}>
        <MenuButton
          as={IconButton}
          aria-label="Options"
          icon={<FontAwesomeIcon icon={faEllipsisVertical} fontSize="16px" />}
          size="xs"
          variant="ghost"
        />
        <MenuList>
          <MenuItem onClick={handleEdit}>Edit</MenuItem>
          <MenuItem onClick={handleRemove}>Remove</MenuItem>
        </MenuList>
      </Menu>
    </DefaultRowCell>
  );
};
